import { LanguageCode, LocalizedClassifierCollection } from "./classifierManager";

const storeClassifiers = (collections: LocalizedClassifierCollection[]) => {
  sessionStorage.setItem("classifiers", JSON.stringify(collections));
};

const getAndParse = <T>(key: string): T | undefined => {
  const storedValue = sessionStorage.getItem(key);
  if (storedValue) {
    return JSON.parse(storedValue);
  }
  return undefined;
};

const getStoredClassifierSets = (languageCode: LanguageCode) => {
  const storedCollections = getAndParse<LocalizedClassifierCollection[]>("classifiers");

  return storedCollections?.find((localizedCollection) => {
    return localizedCollection.languageCode === languageCode;
  })?.classifierSets;
};

const getOrCreateStoredClassifierSets = (languageCode: LanguageCode) => {
  let storedCollections = getAndParse<LocalizedClassifierCollection[]>("classifiers");
  if (storedCollections) {
    if (
      !storedCollections.find((localizedCollection) => {
        return localizedCollection.languageCode === languageCode;
      })
    ) {
      storedCollections.push({
        languageCode,
        classifierSets: [],
      });
    }
  } else {
    storedCollections = [{ languageCode, classifierSets: [] }];
  }
  const storedClassifierSets = storedCollections.find((localizedCollection) => {
    return localizedCollection.languageCode === languageCode;
  })?.classifierSets;

  return {
    storedCollections,
    storedClassifierSets,
  };
};

export { storeClassifiers, getStoredClassifierSets, getOrCreateStoredClassifierSets };
